type CallbackType = (...args: any[]) => any;

class EventEmitter {
    private events: Map<string, CallbackType[]> = new Map();
    private maxListenerLength = 15;

    constructor() {}

    addEvent(eventName: string, callback: CallbackType) {
        const eventList = this.events.get(eventName) || [];
        if(eventList.length > this.maxListenerLength) {
            console.log(`${eventName} 이벤트에 등록된 핸들러 개수가 최대 개수를 초과하였습니다.`);
            return;
        }

        eventList.push(callback);
        this.events.set(eventName, eventList);
    }

    removeEvent(eventName: string, callback: CallbackType) {
        const eventList = this.events.get(eventName);

        if(Array.isArray(eventList) && eventList.length > 0) {
            const funcIndex = eventList.findIndex((cb: CallbackType) => cb === callback);

            if(funcIndex > 0) {
                eventList.splice(funcIndex, 1);
                eventList.length > 0 ? this.events.set(eventName, eventList) : this.events.delete(eventName);
            }
        }
    }

    removeAllEvent() {
        this.events.clear();
    }

    emit(eventName: string, ...args: any[]) {
        const eventList = this.events.get(eventName);

        if(Array.isArray(eventList) && eventList.length > 0) {
            eventList.forEach((cb: CallbackType) => {
                cb(...args);
            });
        }
    }
}

export default EventEmitter;